import { MessageCircle } from "lucide-react";
import { openSubscribe } from "./SubscribeModalHost";
import { useIsSubscribed } from "../lib/useIsSubscribed";
import { DigestLaunchNotice } from "./DigestLaunchNotice";

// Placement 4 — compact article-detail CTA line, dropped in between the
// share buttons row and the Google Translate button.
export const ArticleCTALine = () => {
  const isSubscribed = useIsSubscribed();
  if (isSubscribed) return null;
  return (
    <div className="py-2 space-y-2" data-testid="article-cta-line">
      <div className="flex items-center gap-2 text-[13px]">
        <MessageCircle size={16} className="text-[#25D366] shrink-0" />
        <span className="text-[#1A2E35]">
          Enjoyed this story? Get the daily digest free.
        </span>
        <button
          type="button"
          onClick={() => openSubscribe("article_page")}
          className="text-[#25D366] font-bold hover:underline"
          data-testid="article-cta-line-btn"
        >
          Subscribe →
        </button>
      </div>
      <DigestLaunchNotice
        variant="short"
        testid="article-cta-line-launch-notice"
      />
    </div>
  );
};
